const statusConfig = {
    pending: {
        borderColor: "border-amber-400",
        buttonColor: "bg-amber-400 hover:bg-amber-500 text-white",
        textColor: "text-amber-600",
        label: "در انتظار تأیید",
    },

    processing: {
        borderColor: "border-blue-300",
        buttonColor: "bg-blue-300 hover:bg-blue-400 text-white",
        textColor: "text-blue-500",
        label: "در حال آماده‌سازی",
    },

    completed: {
        borderColor: "border-blue-600",
        buttonColor: "bg-blue-600 hover:bg-blue-700 text-white",
        textColor: "text-blue-700",
        label: "در انتظار پیک",
    },

    delivery: {
        borderColor: "border-teal-500",
        buttonColor: "bg-teal-500 hover:bg-teal-600 text-white",
        textColor: "text-teal-700",
        label: "تحویل شده",
    },

    cancelled: {
        borderColor: "border-red-500",
        buttonColor: "bg-red-500 hover:bg-red-600 text-white",
        textColor: "text-red-600",
        label: "کنسل شده",
    },
    rejected: {
        borderColor: "border-red-600",
        buttonColor: "bg-red-600 hover:bg-red-700 text-white",
        textColor: "text-red-700",
        label: "کنسل شده",
    },
};

export default statusConfig;